import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';
import PointIssueHistoryDetailContainer from '../../containers/point/PointIssueHistoryDetailContainer';

const PointIssueHistoryDetail = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_ISSUE_HISTORY_DETAIL}>
      <PointIssueHistoryDetailContainer />
    </PageTemplate>
  );
};

export default PointIssueHistoryDetail;
